<template>
  <section class="suggested-section" v-if="channels.length">
    <div class="suggested-head">
      <div class="suggested-icon">
        <i class="bi bi-stars" style="font-size:18px" aria-hidden="true"></i>
      </div>
      <div class="suggested-title-wrap">
        <h2 class="suggested-title">
          Profiles found by AI
          <span class="suggested-badge">{{ channels.length }}</span>
        </h2>
        <p class="suggested-desc">
          Not saved yet. Add the ones that belong to this influencer, dismiss the rest.
        </p>
      </div>
      <div class="suggested-bulk" v-if="channels.length > 1">
        <button
          class="bulk-btn bulk-add"
          @click="$emit('accept-all')"
          :disabled="anyPending"
          title="Move all suggestions to profiles"
        >
          <i class="bi bi-plus-lg" aria-hidden="true"></i>
          Add all
        </button>
        <button
          class="bulk-btn bulk-dismiss"
          @click="$emit('dismiss-all')"
          :disabled="anyPending"
          title="Dismiss all suggestions"
        >
          <i class="bi bi-x-lg" aria-hidden="true"></i>
          Dismiss all
        </button>
      </div>
    </div>

    <div class="suggested-list">
      <div class="suggested-row" v-for="(ch, idx) in channels" :key="'sg' + idx">
        <div class="sg-icon">
          <img v-if="ch.platform" :src="platformIconSrc(ch.platform)" :alt="ch.platform"/>
          <span v-else class="sg-fallback">?</span>
        </div>
        <div class="sg-info">
          <span class="sg-platform" v-if="ch.platform">{{ ch.platform }}</span>
          <a class="sg-url" :href="ch.url" target="_blank" rel="noopener">
            <span v-if="ch.username">@{{ ch.username }}</span>
            <span v-else>{{ ch.url }}</span>
          </a>
          <span class="sg-fullurl" v-if="ch.username">{{ ch.url }}</span>
        </div>
        <div class="sg-actions">
          <button
            class="sg-btn sg-add"
            @click="$emit('accept', idx)"
            :disabled="isPending(ch)"
            :title="isPending(ch) ? 'Checking for duplicates…' : 'Check and add to profiles'"
          >
            <span v-if="isPending(ch)" class="spinner"></span>
            <i class="bi bi-plus" v-else aria-hidden="true"></i>
            <span>{{ isPending(ch) ? 'Checking' : 'Add' }}</span>
          </button>
          <button
            class="sg-btn sg-dismiss"
            @click="$emit('dismiss', idx)"
            :disabled="isPending(ch)"
            title="Dismiss"
          >
            <i class="bi bi-x" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'suggested-channels',
    props: {
      channels: {
        type: Array,
        default: () => []
      },
      pendingUrls: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      anyPending() {
        return this.pendingUrls.length > 0;
      }
    },
    methods: {
      isPending(ch) {
        return ch && this.pendingUrls.indexOf(ch.url) !== -1;
      },
      platformIconSrc(platform) {
        try {
          return require('../../assets/platforms/' + platform + '.png');
        } catch (e) {
          return '';
        }
      }
    }
  }
</script>

<style scoped>
  .suggested-section {
    margin-top: 8px;
    padding: 18px 22px;
    border: 1px dashed #fcd34d;
    border-radius: 14px;
    background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
    position: relative;
    overflow: hidden;
  }
  .suggested-head {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding-bottom: 14px;
    border-bottom: 1px dashed #fcd34d;
    margin-bottom: 14px;
  }
  .suggested-icon {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: #ede9fe;
    color: #6d3fc4;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .suggested-title-wrap {
    flex: 1;
    min-width: 0;
  }
  .suggested-title {
    font-size: 15px;
    font-weight: 600;
    margin: 0 0 4px;
    color: #78350f;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  .suggested-badge {
    background: #fbbf24;
    color: #78350f;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 999px;
  }
  .preview-badge {
    background: rgba(120, 53, 15, 0.12);
    color: #78350f;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 4px;
    letter-spacing: 0.06em;
  }
  .suggested-desc {
    font-size: 12.5px;
    color: #92400e;
    margin: 0;
    line-height: 1.5;
  }
  .suggested-desc strong { font-weight: 600; }
  .suggested-bulk {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex-shrink: 0;
  }
  .bulk-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 5px 10px;
    border-radius: 6px;
    font-size: 11.5px;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid;
    background: transparent;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
    white-space: nowrap;
  }
  .bulk-add {
    border-color: #fbbf24;
    color: #92400e;
  }
  .bulk-add:hover {
    background: #fbbf24;
    color: #fff;
  }
  .bulk-dismiss {
    border-color: rgba(120, 53, 15, 0.25);
    color: #92400e;
  }
  .bulk-dismiss:hover {
    background: rgba(120, 53, 15, 0.08);
  }

  .suggested-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .suggested-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.75);
    border: 1px solid #fde68a;
    border-radius: 10px;
    transition: border-color 0.15s, background 0.15s;
  }
  .suggested-row:hover {
    background: #fff;
    border-color: #fbbf24;
  }
  .sg-icon {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    background: #fff;
    border: 1px solid #fde68a;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .sg-icon img {
    width: 22px;
    height: 22px;
    border-radius: 4px;
  }
  .sg-fallback {
    color: #d97706;
    font-weight: 600;
    font-size: 14px;
  }
  .sg-info {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }
  .sg-platform {
    font-size: 10.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #92400e;
    line-height: 1.2;
  }
  .sg-url {
    font-size: 13.5px;
    color: #0f172a;
    text-decoration: none;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sg-url:hover {
    color: #265a88;
    text-decoration: underline;
  }
  .sg-fullurl {
    font-size: 11.5px;
    color: #a16207;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 2px;
  }
  .sg-actions {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
  }
  .sg-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background: transparent;
    border: 1px solid;
    border-radius: 7px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s, color 0.15s, border-color 0.15s, opacity 0.15s;
    min-width: 70px;
    justify-content: center;
  }
  .sg-btn:disabled {
    cursor: not-allowed;
    opacity: 0.75;
  }
  .sg-add {
    background: #fbbf24;
    border-color: #fbbf24;
    color: #fff;
  }
  .sg-add:hover:not(:disabled) {
    background: #d97706;
    border-color: #d97706;
  }
  .sg-dismiss {
    background: transparent;
    border-color: rgba(120, 53, 15, 0.2);
    color: #92400e;
    padding: 6px 8px;
    min-width: auto;
  }
  .sg-dismiss:hover:not(:disabled) {
    background: #fef2f2;
    border-color: #fecaca;
    color: #dc2626;
  }
  .spinner {
    display: inline-block;
    width: 11px;
    height: 11px;
    border: 2px solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    animation: sg-spin 0.7s linear infinite;
  }
  @keyframes sg-spin {
    to { transform: rotate(360deg); }
  }

  .bulk-btn:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .bulk-add:hover:disabled,
  .bulk-dismiss:hover:disabled {
    background: transparent;
  }

  @media (max-width: 640px) {
    .suggested-head {
      flex-wrap: wrap;
    }
    .suggested-bulk {
      flex-direction: row;
      width: 100%;
    }
    .bulk-btn { flex: 1; text-align: center; }
    .suggested-row {
      flex-wrap: wrap;
    }
    .sg-actions {
      width: 100%;
      justify-content: stretch;
    }
    .sg-actions .sg-btn {
      flex: 1;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/influencer/SuggestedChannels.vue